import React from 'react'
import { useHistory } from 'react-router-dom'
import cn from 'classnames'

import OrderInformation from './OrderInformation'
import SidebarModal from '../../SidebarModal'
import Button from '../../Button'

import OrderState from '../../../utils/orderStates'

import styles from './SplitOrder.module.scss'
import BackChevron from '../../BackChevron'

const SplitOrder = ({ orderId, orderState, orderNumber, modifiedAt, subtotal, suiteInformation, userNotes, payment, remoteOrderTotal, onClose, className }) => {
  const classNames = cn(styles.splitOrder, className)
  const history = useHistory()

  const isDisabled = OrderState.isClosed(orderState)

  return (
    <SidebarModal
      show
      title="Split Order"
      onClose={onClose}
      leftAccessory={<BackChevron onClick={() => history?.replace?.(`/tabs/${orderId}/more`)} />}
      className={classNames}
    >
      <OrderInformation account={suiteInformation?.displayName} payment={payment} amount={remoteOrderTotal?.subtotalDisplay ?? subtotal} grandTotal={remoteOrderTotal?.totalDisplay ?? "$0.00"} modifiedAt={modifiedAt} orderNumber={orderNumber} note={userNotes} />
      <p className={styles.separator}></p>

      {isDisabled &&
        <div className={styles.bodyContainer}>
          <div className={styles.warning}>
            This order is closed and can not be split at this time.
          </div>
        </div>
      }
      {!isDisabled &&
        <div className={styles.bodyContainer}>
          <div className={styles.buttonContainer}>
            <Button key='byItems' onClick={() => history?.replace?.(`/tabs/${orderId}/split-by-items`)} className={styles.actionButton}>By Items</Button>
            {/* temporarily disabling split by percent <Button key='byPercent' onClick={() => history?.replace?.(`/tabs/${orderId}/split-by-percent`)} className={styles.actionButton}>By Percent</Button> */}
            <Button key='byAmount' onClick={() => history?.replace?.(`/tabs/${orderId}/split-by-dollar`)} className={styles.actionButton}>By $ Amount</Button>
          </div>
        </div>
      }
    </SidebarModal>
  )
}

export default SplitOrder
